import admissionStatistic from './components/statistic.vue';

export default {
  routes: [
    {
      path: '/',
      component:admissionStatistic,
      name:'admissionStatistic'
    }
  ]
};
